import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { ImportType } from 'library/ts/model/enums/config/ImportType';
import { ImportVO } from 'library/ts/model/vo/ImportVO';
import { LogService } from 'library/ts/utilities/logger/LogService';
const logger = LogService.create({ prefixes: ['SmartTag:', 'PluginUtilities:'] });
export class PluginUtilities {
    static getPluginsDictionaryForOwnerClass = (ownerClass, config) => {
        const utils = window?.SmartTag?.utilities;
        Object.keys(config).forEach((key) => {
            const module = config[key];
            if (module?.category === ConfigModuleCategory.PLUGIN) {
                if (module?.params?.owner === ownerClass?.name) {
                    if (utils.Type.isUndefined(ownerClass.plugins))
                        ownerClass.plugins = {};
                    if (utils.Type.isUndefined(ownerClass.plugins[key])) {
                        ownerClass.plugins[key] = {};
                    }
                    ownerClass.plugins[key].name = key;
                    ownerClass.plugins[key] = utils.DeepMerge.deepmerge(ownerClass.plugins[key], module);
                    ownerClass.plugins[key].object = utils.DOM.getDeepVal(window, ownerClass.plugins[key].params.import.app.namespace);
                }
            }
        });
        return ownerClass.plugins;
    };
    static setupPluginsForOwnerClass = (argument = {
        ownerClass: undefined,
        framework: undefined,
        config: undefined
    }) => {
        const ownerClass = argument?.ownerClass;
        const framework = argument?.framework;
        const config = argument?.config;
        return new Promise((resolve, reject) => {
            const utils = window?.SmartTag?.utilities;
            ownerClass.plugins = PluginUtilities.getPluginsDictionaryForOwnerClass(ownerClass, config);
            if (utils.Type.isObject(ownerClass.plugins) && Object.keys(ownerClass.plugins).length > 0) {
                logger.log(ownerClass.uuid, ownerClass.name, 'setupPlugins:', 'Plugin configs were found => check if plugins are enabled and loaded + instantiate:', ownerClass.plugins);
                Object.keys(ownerClass.plugins).forEach((key) => {
                    const pluginConfig = ownerClass.plugins[key];
                    if (utils.Type.isFunction(pluginConfig.object) && utils.Type.isUndefined(pluginConfig.instance)) {
                        pluginConfig.instance = new pluginConfig.object({
                            framework: framework,
                            config: pluginConfig,
                            owner: ownerClass
                        });
                    }
                });
                utils.Delay.delay(undefined)
                    .then(() => {
                    resolve({ success: true, plugins: ownerClass.plugins, msg: `Plugins for ${ownerClass.name} were instantiated!` });
                });
            }
            else {
                const msg = `No plugins configs were found for ${ownerClass.name}. Exit without instantiation!`;
                resolve({ success: false, plugins: ownerClass.plugins, msg: msg });
            }
        });
    };
    static loadPluginScripts = (argument = {
        uuid: undefined,
        config: undefined,
        ignorePreloadFlag: false,
        ownerClassName: undefined
    }) => {
        const uuid = argument?.uuid;
        const config = argument?.config;
        const ignorePreloadFlag = argument?.ignorePreloadFlag || false;
        const ownerClassName = argument?.ownerClassName;
        const runtimeVO = window?.SmartTag?.runtimeVO;
        const utils = window?.SmartTag?.utilities;
        return new Promise((resolve, reject) => {
            const imports = [];
            Object.keys(config).forEach((moduleName) => {
                const module = config[moduleName];
                if (utils.Type.isEmpty(module?.category) === false && utils.Type.isString(module?.category)) {
                    if (module?.category === ConfigModuleCategory.PLUGIN
                        &&
                            module?.enabled === true
                        &&
                            module?.params?.owner === ownerClassName
                        &&
                            (module?.params?.preload === true
                                ||
                                    (module?.params?.preload === false && ignorePreloadFlag === true))) {
                        logger.log(uuid, 'preloadPlugins', 'Plugin to preload:', moduleName, module);
                        if (utils.Type.isEmpty(module?.params?.import) === false && utils.Type.isObject(module?.params?.import)) {
                            Object.keys(module.params.import).forEach((key) => {
                                const importable = module.params.import[key];
                                if (importable.enabled === true) {
                                    if (runtimeVO?.readyCallback?.payload?.relative === true) {
                                        importable.url.regular = utils.URL.convertToRelative(importable?.url?.regular);
                                    }
                                    const url = importable?.url?.regular;
                                    if (utils.URL.valid(url)) {
                                        const importVO = new ImportVO(importable.type, url, undefined, undefined, undefined, ConfigModuleCategory.PLUGIN, module?.params?.owner);
                                        importVO.namespace = (importable.type === ImportType.SCRIPT ? importable?.namespace : undefined);
                                        importVO.location = (importable.type === ImportType.SCRIPT ? window : undefined);
                                        imports.push(importVO);
                                    }
                                }
                            });
                        }
                    }
                }
            });
            if (imports.length === 0) {
                resolve({ msg: 'No plugins marked for pre-load were found' });
            }
            if (imports.length > 0) {
                logger.log(uuid, 'preloadPlugins', 'Plugin imports to preload:', imports);
                imports.forEach((importIO) => {
                    if (runtimeVO.top.ssl)
                        importIO.url = utils.URL.toHTTPS(importIO.url);
                    importIO.url = utils.URL.addCacheToken(importIO.url, runtimeVO.debug.cacheBust);
                });
                utils.Importer.import(imports, true).then((result) => {
                    logger.log(uuid, 'preloadPlugins', 'preload done:', result);
                    result.msg = 'preloadPlugins, preload done';
                    resolve(result);
                }).catch((error) => {
                    logger.warn(uuid, 'preloadPlugins', 'preload failure:', error);
                });
            }
        });
    };
    static appendPluginDomContainer = (argument = {
        config: undefined,
        rootContainer: undefined
    }) => {
        const config = argument?.config;
        const rootContainer = argument?.rootContainer;
        return new Promise((resolve, reject) => {
            const utils = window?.PARA?.PlayerServices?.Utilities;
            const resolvePromise = (container, msg = `${config.name}: DOM container created`) => {
                resolve({ msg: msg, container: container });
            };
            const rejectPromise = (error, msg = `${config.name}: DOM container creation failed`) => {
                reject({ msg: msg, error: error, element: undefined });
            };
            if (utils.Type.isEmpty(config?.params?.css?.container)) {
                utils.Delay.delay().then(() => rejectPromise(new Error(`${config.name}: DOM container creation failed: No CSS container string was found. Return undefined`)));
            }
            const container = utils.DOM.stringToElement(`<div class='${config?.params?.css?.container}'></div>`);
            let methodName;
            let referenceElementClass;
            if (!utils.Type.isEmpty(config?.params?.css?.insertAfter) && utils.Type.isString(config.params.css.insertAfter)) {
                methodName = 'insertAfter';
                referenceElementClass = config.params.css.insertAfter;
            }
            if (!utils.Type.isEmpty(config?.params?.css?.insertBefore) && utils.Type.isString(config.params.css.insertBefore)) {
                methodName = 'insertBefore';
                referenceElementClass = config.params.css.insertBefore;
            }
            if (utils.Type.isEmpty(referenceElementClass) && utils.Type.isEmpty(methodName)) {
                rootContainer.appendChild(container);
                utils.Delay.delay().then(() => resolvePromise(container));
            }
            const referenceElement = rootContainer.querySelector('.' + referenceElementClass);
            if (referenceElement === null) {
                utils.Delay.delay().then(() => rejectPromise(new Error(`${config?.name}: DOM container creation failed: No reference element was found. Return undefined`)));
            }
            else {
                utils.DOM[methodName](container, referenceElement);
                utils.Delay.delay().then(() => resolvePromise(container));
            }
        });
    };
}
